import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 8 4-4 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 4v16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 10V4h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 10h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { x: "15", y: "14", width: "4", height: "6", ry: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUp10";
const ArrowUp10 = memo(themed(Icon));
export {
  ArrowUp10
};
//# sourceMappingURL=arrow-up-1-0.js.map
